import { useState, useCallback, useMemo } from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory as createHistory } from "history";
import Routes from "./routes";
import SmartBanner from "react-smartbanner";
import { TaskContext } from "./contexts";
import { useSentry } from "./useSentry";
const history = createHistory();

const App = () => {
  useSentry(history)
  const [activeTasks, setActiveTasks] = useState([]);


  const formatTasks = useCallback((tasks) => {
    const area = history.location.pathname.split("/")[2];
    const filteredTasks = tasks.filter(
      ({ required }) => area === undefined || required.includes(area)
    );
    setActiveTasks(filteredTasks);
  }, []);

  const hasCompletedAllTasks = useMemo(() =>
    activeTasks.find(({ complete, optional }) => {
      return !complete && !optional;
    }) === undefined, [activeTasks]);

  return (
    <>
      <SmartBanner title="Clever Clinic" />
      <TaskContext.Provider
        value={{ activeTasks, hasCompletedAllTasks, formatTasks }}
      >
        <Router history={history}>
          <Routes />
        </Router>
      </TaskContext.Provider>
    </>
  );
};

export default App;
